import React, { Component } from 'react';
import CustomPaginationActionsTable from '../table/CustomPaginationActionsTable';
import { updateMenu } from '../../../container/actions/menu-action'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import AddCircle from '@material-ui/icons/AddCircle';
import Search from '../../content/search/Search';
import PropTypes from 'prop-types';
import {
    NavLink,
} from "react-router-dom";

import "./ListingScreen.css";

class ClientList extends Component {
    data = [];
    criteres = {};

    constructor(props) {
        super(props);
        this.state = {
            criteres: null,
        };
        this.criteres["value"] = null;
        this.editRow = this.editRow.bind(this);
    }

    loadData = newCriteres => {
        this.setState({ criteres: newCriteres });
    }

    editRow = (rowID, key) => (event) => {
        console.log(`Edit row: ${key}`);
        this.props.editRow(this.props.path, key);
    }

    addEvent() {
        if (this.props.tableColumnsAction.length > 0) {
            this.props.tableColumnsAction.forEach(col => { col["event"] = this.editRow; });
        }
    }

    renderAddElem() {
        if (this.props.addButton) {
            return (
            <NavLink to={this.props.path} className="dataListAddData" title={this.props.labelCreation} onClick={this.editRow(0, null)}>
                <AddCircle className="dataListAddDataIcon" />
            </NavLink>);
        }
        return "";
    }

     
    render() {
        this.addEvent();
        this.data = this.props.service(this.state.criteres);
        return (
            <div className="dataList">
                <Search action={this.loadData} label={this.props.labelRecherche} />
                {this.renderAddElem()}

                <CustomPaginationActionsTable tableColumns={this.props.tableColumns} tableColumnsAction={this.props.tableColumnsAction} tableRowDatas={this.data} />
            </div>
        );
    }
}

CustomPaginationActionsTable.propTypes = {
    tableColumns: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })),
    tableColumnsAction: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
        label: PropTypes.string.isRequired,
        event: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired,
        typeAction: PropTypes.string.isRequired,
    })),
    service: PropTypes.func,
    path: PropTypes.string,
    addButton: PropTypes.bool,
    labelCreation: PropTypes.string,
    labelRecherche: PropTypes.string,
};

const mapStateToProps = props => ({
    menu: props.url
});

const mapActionsToProps = (dispatch) => {
    return bindActionCreators({
        editRow: updateMenu
    }, dispatch)
};

export default connect(mapStateToProps, mapActionsToProps)(ClientList);


// WEBPACK FOOTER //
// ./src/components/custom/listingScreen/ListingScreen.js